import UserList from './UserListTable';

export default UserList;
